module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "bodyMatter"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "chapterTitle"
  }, [_c('span', {
    staticClass: "xrefInternal"
  }, [_c('a', {
    attrs: {
      "href": "#/contents#ch_01"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("It’s Not Daytona—You’re Not Jeff Gordon")])])])]), _vm._v(" "), _c('p', {
    staticClass: "chapterSubtitle"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Don’t Try to Cook"), _c('br'), _vm._v(" Tailgating Turkeys")])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText"
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("H")])]), _vm._v("ere they are—another set of holidays, another set of packed roads and parking lots, long drives to family gatherings in bad weather, and impromptu trips to the market when your cocktail party runs out of cocktail weenies. Holidays mean hitting the highways, and highways and roads can be unbearably jammed from Thanksgiving to whenever the last New Year’s Day partier straggles home. There is a stocking-full of reasons the Most Wonderful Time of the Year can put us on the road—and in a rage. The holidays should probably come with a “D"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ON")]), _vm._v("’"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("T")]), _vm._v(" D"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("RIVE OR")]), _vm._v(" O"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("PERATE")]), _vm._v(" H"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("EAVY")]), _vm._v(" M"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ACHINERY")]), _vm._v("” warning label.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Anyone who’s ever had an unfortunate encounter with an automobile knows they can do a lot of damage, especially when the people driving them just had a few drinks at their office party, or recently went to four toy stores looking for the only item their seven-year-old has asked Santa for, or have blocked their "), _c('a', {
    attrs: {
      "id": "page11"
    }
  }), _vm._v("rearview mirror’s view with a big fat box. Sharing the road with these drivers (I know you’d never actually be one of them) can be scary and challenging in normal circumstances, let alone when you’re feeling hurried and harried, overbooked and overwhelmed.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Our highest priority when strapped into metal and glass boxes traveling at high speeds is safety—not being right, not getting there first, and not teaching other people how to drive. So when someone’s tailgating you, or you’re navigating a four-way stop, or another driver near you is having trouble staying between the white lines, the safest thing to do is yield.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Too many people play games with tailgaters—slamming on the brakes, letting them pass, and then showing them how it feels by riding their bumper. But this is no game—it is life or death.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("So yield, change lanes, pull over, and call the police, if you’re really that heated. I mean this advice literally and figuratively. In case my symbolism isn’t crystal clear, the preceding rules apply to the road of life as well as the road of…well, you know, the road. Giving turkeys a wide berth is often the fastest and safest way to arrive safely at your destination. You may feel momentarily scrooged, but at least you won’t have scars and stitches in this year’s holiday photo.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("So here are your keys. Enjoy the holidays.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-258aac0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ch01.vue
// module id = 72
// module chunks = 0